/* @flow */
import isString from 'lodash.isstring';
import escapeRegExp from 'lodash.escaperegexp';
import { pipe, replace } from 'ramda';

const dangerousPatterns = [
  // URL:
  /((https?:\/\/)?www\.)?(\S+\.)+(\S+)/,
  // IP:
  /(\d+\.){3}\d/,
];

const dotPatterns = '(\\.|\\[\\.\\]|\\(\\.\\)|\\{\\.\\})';

export const defang = (text: string): string => {
  return dangerousPatterns.reduce((cleanString, pattern) => {
    return cleanString && isString(cleanString) ? cleanString.replace(RegExp(pattern, 'gi'), (match) => {
      // only put [ ] around .
      return match
        ? match.replace(/\./g, '[.]').replace(/http/i, 'hxxp').replace(/ftp/i, 'fxp')
        : match;
      // should find another way to deal with other protocols
    }) : cleanString;
  }, text);
};

/**
 * NOTE: Since we are running replacement on escaped regex we replace the
 * literal '\.' instead of the literal '.'
 */
const matchReplace = pipe(
  replace(/\\\./g, dotPatterns), // only put [ ] around ".". See NOTE
  replace(/http/i, '(http|hxxp)'),
  replace(/ftp/i, '(ftp|fxp)')
);

/**
 * NOTE: This needs to be called with an escaped regex string.
 */
const defangRegex = (escapedRegexString: string): string => {
  return dangerousPatterns.reduce((cleanString, pattern) => {
    return (cleanString && isString(cleanString)) ? cleanString.replace(RegExp(pattern, 'gi'), (match) => {
      return match ? matchReplace(match) : match;
    }) : cleanString;
  }, escapedRegexString);
};

export const escapeDefangRegex = pipe(escapeRegExp, defangRegex);



// WEBPACK FOOTER //
// ./web_modules/trustar/reports/defang.js